import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminJoin from "./components/AdminJoin";
import UserJoin from "./components/UserJoin";
import ThankYou from "./components/ThankYou"; // Import new component

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminJoin />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/*" element={<UserJoin />} />
      </Routes>
    </Router>
  );
}

export default App;

// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import AdminJoin from "./components/AdminJoin";
// import UserJoin from "./components/UserJoin";

// function App() {

//   return (
//     <Router>
//       <Routes>
//         <Route path="/admin" element={<AdminJoin />} />
//         <Route path="/*" element={<UserJoin />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// return (
//   <Router>
//     <div className="app-container">
//       <Routes>
//         <Route path="/admin" element={<AdminJoin />} />
//         <Route path="/*" element={<UserJoin />} />
//       </Routes>
//     </div>
//   </Router>
// );

// import React from 'react';
// import WalkieTalkie from './components/WalkieTalkie';

// function App() {
//   return (
//     <div className="app-container">
//       <h1>Walkie-Talkie Voice Room</h1>
//       <WalkieTalkie />
//     </div>
//   );
// }

// export default App;

// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
